var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPostIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33333 4.35583C4.59695 4.35583 4 4.95279 4 5.68917V19.0225C4 19.7589 4.59695 20.3558 5.33333 20.3558H18.6667C19.403 20.3558 20 19.7589 20 19.0225V5.68917C20 4.95279 19.403 4.35583 18.6667 4.35583H5.33333ZM14.1664 5.35583H9.83362V9.18903L14.1664 9.18903V5.35583ZM14.1664 10.189L9.83362 10.189V14.5226L14.1664 14.5226V10.189ZM8.83362 9.18903V5.35583H5.33333C5.14924 5.35583 5 5.50507 5 5.68917V9.18903H8.83362ZM5 10.189H8.83362V14.5226H5V10.189ZM15.1664 10.189H19V14.5226H15.1664V10.189ZM19 9.18903H15.1664V5.35583H18.6667C18.8508 5.35583 19 5.50507 19 5.68917V9.18903ZM8.83362 15.5226H5V19.0225C5 19.2066 5.14924 19.3558 5.33333 19.3558H8.83362V15.5226ZM14.1664 15.5226L9.83362 15.5226V19.3558H14.1664V15.5226ZM15.1664 19.3558V15.5226H19V19.0225C19 19.2066 18.8508 19.3558 18.6667 19.3558H15.1664Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostIcon);
export default __webpack_public_path__ + "static/media/postIcon.f4470c55.svg";
export { ForwardRef as ReactComponent };